import { parse, stringify } from 'query-string';
import useStewardshipFilter from '../../projects/useStewardshipFilter';
import { MISSING_FIELDS_$AGGREGATIONS, MISSING_FIELDS_$HAVING } from '../../projects/MISSING_FIELDS';
import { useConnect } from '../../../../hooks/@lore/query-connect';

export default function useQuery(props) {
  const { location, PAGE_SIZE = 10, extra = {} } = props;

  const stewardshipFilter = useStewardshipFilter();

  return useConnect('project.find', {
    where: {
      eager: {
        $aggregations: MISSING_FIELDS_$AGGREGATIONS,
        $where: {
          // published: false,
          // cancelled: false,
          activityId: {
            $null: false
          },
          // $and: {
          //   $or: MISSING_FIELDS
          // },
          $or: stewardshipFilter,
          ...extra
        },
        $having: MISSING_FIELDS_$HAVING,
      }
    },
    pagination: {
      page: parse(location.search).page || '1',
      pageSize: PAGE_SIZE,
      order: 'createdAt desc'
    }
  }, {
    keepPreviousData: true
  });
}
